// test89
(89 && 0);
